import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
  output,
} from '@angular/core';
import { ButtonDesignTokens } from '@primeuix/themes/types/button';
import { ButtonModule } from 'primeng/button';

import { SharedButtonType } from './button.constants';

@Component({
  selector: 'shared-button',
  imports: [CommonModule, ButtonModule],
  templateUrl: './button.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SharedButtonComponent {
  public type = input.required<SharedButtonType>();
  public autofocus = input<boolean>(false);
  public icon = input<string>();
  public iconPos = input<'left' | 'right'>('left');
  public isDisabled = input<boolean>(false);
  public label = input<string>();
  public size = input<'small' | 'large'>('large');
  public dt = input<ButtonDesignTokens>();
  public loading = input<boolean>(false);

  public clickEvent = output<MouseEvent | undefined>();

  public iconClass = computed(() =>
    this.icon() ? `pi pi-${this.icon()}` : undefined,
  );
  public severity = computed(() =>
    this.type() === SharedButtonType.Primary ? 'success' : undefined,
  );
  public isLink = computed(() => this.type() === SharedButtonType.Link);
  public sharedButtonType = SharedButtonType;
  public pt = input<any>();

  onClick(event?: MouseEvent): void {
    this.clickEvent.emit(event);
  }
}
